module.exports = __webpack_public_path__ + "img/invid-logo.ed707ace.png";